import { getTranslations } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';

/** Lookup helper for the `workflowCompletions` i18n namespace. */
export const workflowTranslation = (path: string[]): TranslatedString =>
  getTranslations({ fileName: 'workflowCompletions', translationPath: path });
